import PropTypes from "prop-types";
import CustomImage from "../../../components/atoms/customImage";
import Toast from "../../../components/atoms/toast";
import { constants } from "../../../constants/pageConstants/pdpConstants";
import { plpBannerConstants } from "../../../constants/pageConstants/plpConstants";
import { useState } from "react";

/**
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.specialDateCouponDetails
 * @returns {JSX.Element}
 */
const SpecialDateCoupon = ({ specialDateCouponDetails, isMobile }) => {
  const { date, couponCode, discountMsg, messageLine1, messageLine2 } = specialDateCouponDetails;
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  if (!(couponCode && date && discountMsg && messageLine1 && messageLine2)) {
    return null;
  }

  /**
   * This function is used to copy the coupon code when click on the copy code button.
   *
   */
  const onHandleCopyText = () => {
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard
        .writeText(couponCode)
        .then(() => {
          setIsTooltipVisible(true);
        })
        .catch((err) => err);
    }
  };

  /**
   *
   * @returns
   */
  const codeCopiedText = () => (
    <Toast
      variant={constants.SUCCESS}
      isToast={isTooltipVisible}
      header={plpBannerConstants.CODE_COPIED}
      duration={3000}
      position="fixed bottom-80"
      // eslint-disable-next-line react/jsx-handler-names
      onToastChange={() => setIsTooltipVisible(false)}
    />
  );

  /**
   * specialCouponMsgLine render messageLine2 with dynamic discount and coupon information.
   */
  const specialCouponMsgLine = () => {
    const splitByDate = messageLine1.split("%date%");
    const splitByDiscount = messageLine2.split("%discountMsg%");
    const splitByCoupon = splitByDiscount[1]?.split("%couponCode%")[0];

    return (
      <>
        <span>{`${splitByDate[0]} ${date} ${splitByDate[1]} ${splitByDiscount[0]}`}</span>
        {isMobile ? <br /> : null}
        <span className="px-4 font-600">{discountMsg}</span>
        <span>{splitByCoupon}</span>
        <span className="cursor-pointer pl-4 font-600" onClick={onHandleCopyText}>
          {couponCode}
        </span>
      </>
    );
  };

  return (
    <>
      <div className="mt-8">
        <div className="relative flex rounded-full border-1 border-darkOliveGreen/10 bg-gradient-to-r from-[#dbdfb5] to-[#f9faf2] px-12 py-8 pr-40">
          <p className="flex flex-wrap items-center text-12 font-500">{specialCouponMsgLine()}</p>
          <div className="absolute inset-y-0 right-0 top-0 flex h-full items-center justify-center p-12">
            <CustomImage src="/icons/green-chevron.svg" width={16} height={16} isPriority={false} alt="green-chevron" />
          </div>
        </div>
      </div>
      {isTooltipVisible && codeCopiedText()}
    </>
  );
};
SpecialDateCoupon.propTypes = {
  specialDateCouponDetails: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
};
export default SpecialDateCoupon;
